// extracted by mini-css-extract-plugin
export default {"MessageChat":"MessageChat_MessageChat__PTrni","user":"MessageChat_user__cIBW3","text":"MessageChat_text__ovhvl","icon":"MessageChat_icon__6DP10","time":"MessageChat_time__o20ud"};